<h2 mat-dialog-title>Lisää tiimi kokonaisuuteen "{{ data.kokonaisuusNimi }}"</h2>
<mat-dialog-content>
  <form novalidate>
    <mat-form-field style="width: 100%">
      <mat-label>Tiimi</mat-label>
      <mat-select [formField]="lomake.tiimiAvain">
        @for (tiimi of data.valittavissaOlevatTiimit; track tiimi.avain) {
          <mat-option [value]="tiimi.avain">{{ tiimi.nimi }}</mat-option>
        }
      </mat-select>
      @if (data.valittavissaOlevatTiimit.length === 0) {
        <mat-hint>Kaikki tiimit ovat jo aktiivisia kokonaisuudessa.</mat-hint>
      }
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Voimassa alkaen</mat-label>
      <input matInput [matDatepicker]="dpAlku" [formField]="lomake.alku" />
      <mat-datepicker-toggle matSuffix [for]="dpAlku"></mat-datepicker-toggle>
      <mat-datepicker #dpAlku></mat-datepicker>
    </mat-form-field>

    <mat-form-field style="width: 100%">
      <mat-label>Voimassa päättyen</mat-label>
      <input matInput [matDatepicker]="dpLoppu" [formField]="lomake.loppu" />
      <mat-datepicker-toggle matSuffix [for]="dpLoppu"></mat-datepicker-toggle>
      <mat-datepicker #dpLoppu></mat-datepicker>
      <mat-hint>Tyhjä = voimassa toistaiseksi</mat-hint>
    </mat-form-field>
  </form>
  @if (virhe) {
    <div class="red-text" style="margin-top: 8px">{{ virhe }}</div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <app-secondary-button style="margin-right: 10px" (click)="peruuta()" actionId="Peruuta tiimin lisäys kokonaisuuteen">Peruuta</app-secondary-button>
  <app-primary-button (click)="tallenna()" actionId="Lisää tiimi kokonaisuuteen" [actionContext]="[data.kokonaisuusAvain, lomake.tiimiAvain().value(), lomake.alku().value(), lomake.loppu().value()]" [disabled]="!lomake().valid()">Lisää</app-primary-button>
</mat-dialog-actions>
